//#region src/logic/ceremonyOutcome.ts
var e = (e, t) => {
	if (e.verified && e.resultToken && (t === void 0 || e.purpose === t)) return {
		kind: "proof",
		resultToken: e.resultToken
	};
	switch (e.reason) {
		case "no_proof": return { kind: "reconcile" };
		case "unsupported": return { kind: "unsupported" };
		case "popup_blocked": return { kind: "blocked" };
		case "closed":
		case "timeout": return { kind: "abandoned" };
		default: return { kind: "failed" };
	}
};
//#endregion
export { e as resolveCeremonyOutcome };
